import React, { useState, useEffect, useContext } from "react";
import { Typography, Grid } from "@mui/material";
import { Container } from "@mui/system";
import { Helmet } from "react-helmet-async";
import { publicApi } from "../../api/http";
import { DraftYearContext } from "../../contexts/DraftYearContext";
import IndependentRankingCard from "../../components/IndependentRankingCard/IndependentRankingCard";
import PageLoader from "../../components/PageLoader/PageLoader";

function IndependentRankings() {
  const { draftYear } = useContext(DraftYearContext);
  const [rankings, setRankings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [draftYearChange, setDraftYearChange] = useState(true);
  const [prevDraftYear, setPrevDraftYear] = useState(null);

  useEffect(() => {
    setLoading(true);
    publicApi
      .get(`/independent_rankings`, {
        params: { draft_year: draftYear },
      })
      .then((response) => {
        setRankings(response.data || []);
        setLoading(false);
      })
      .catch(() => {
        setRankings([]);
        setLoading(false);
      });
  }, [draftYear]);

  useEffect(() => {
    if (prevDraftYear == null) {
      setPrevDraftYear(draftYear);
    } else if (prevDraftYear !== draftYear) {
      setDraftYearChange(false);
    }
    setPrevDraftYear(draftYear);
  }, [draftYear]);

  function getIsLoading() {
    return loading && !draftYearChange;
  }

  return (
    <>
      <Helmet>
        <title>Independent Rankings - Hockey Pipeline</title>
        <meta
          name="description"
          content="Independent NHL prospect rankings from Hockey Pipeline scouts, separate from publication mock drafts."
        />
        <link rel="canonical" href="https://hockeypipeline.com/independent-rankings" />
      </Helmet>
      <PageLoader loading={getIsLoading()} />
      <Container className="container top-container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4" component="div" className="page-title">
              Independent Rankings
            </Typography>
            <div className="title-underline" />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{ color: "var(--text-muted)", maxWidth: 720, mb: 1 }}
            >
              Standalone scout rankings from Hockey Pipeline users, separate from
              publication-linked media rankings.
            </Typography>
          </Grid>
          {rankings.length === 0 && !loading && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ color: "var(--text-muted)" }}>
                No public independent rankings for {draftYear} yet.
              </Typography>
            </Grid>
          )}
          {rankings.map((ranking) => (
            <Grid item xs={12} key={ranking.independent_ranking_id}>
              <IndependentRankingCard ranking={ranking} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}

export default IndependentRankings;
